import { combineReducers } from "redux";
import loginSignPopUp from './loginSignPopUp'
export default combineReducers({
    loginSignPopUp,
    // package: packageReducer
});